import { Component, DestroyRef, ElementRef, inject, input, output, viewChild } from '@angular/core'
import { FocusMonitor } from '@angular/cdk/a11y'
import { HapticService } from '../../services/haptic-service/haptic.service'
import { SearchInputComponent } from '../search-input/search-input.component'

/** Inline search field shared by mobile entity lists. */
@Component({
  selector: 'aw-inline-list-search',
  templateUrl: './inline-list-search.component.html',
  styleUrl: './inline-list-search.component.scss',
  imports: [SearchInputComponent]
})
export class InlineListSearchComponent {
  protected readonly haptics = inject(HapticService)
  private readonly searchInput = viewChild.required(SearchInputComponent)
  readonly placeholder = input.required<string>()
  readonly currentValue = input('')

  readonly searchChanged = output<string>()

  constructor() {
    const focusMonitor = inject(FocusMonitor)
    const element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement

    // A tap on a text field also matches `:focus-visible`. Track how focus arrived, so only keyboard focus draws the ring.
    focusMonitor.monitor(element, true)
    inject(DestroyRef).onDestroy(() => focusMonitor.stopMonitoring(element))
  }

  /** Focuses search when its owning sheet has finished opening. */
  focus(): void {
    this.searchInput().focus()
  }
}
